<div class="review-header">
  <div class="review-header__text">
    <span class="review-header__eyebrow">AI Extraction Complete</span>
    <span class="review-header__title">Review Extracted Fields</span>
    <span class="review-header__subtitle"
      >Verify and edit before saving. Click any field to edit inline.</span
    >
  </div>
  <button
    mat-icon-button
    class="review-header__close"
    [disabled]="saving()"
    (click)="cancel()">
    <mat-icon>close</mat-icon>
  </button>
  <div class="review-header__meta">
    <span class="meta-pill meta-pill--file">
      <mat-icon>description</mat-icon>
      {{ fileName }}
    </span>
    <span class="meta-pill meta-pill--count">
      <mat-icon>auto_awesome</mat-icon>
      {{ totalFieldCount }} fields extracted
    </span>
    @if (hasSubFacilities) {
      <span class="meta-pill meta-pill--facilities">
        <mat-icon>layers</mat-icon>
        {{ subFacilities.length + 1 }} facilities
      </span>
    }
  </div>
</div>

<mat-dialog-content class="review-body">
  <form [formGroup]="form" class="required-form">
    <div class="review-section">
      <div class="review-section__title">Deal</div>

      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Deal Name</mat-label>
        <input
          matInput
          type="text"
          [ngModel]="dealName()"
          (ngModelChange)="dealName.set($event)"
          [ngModelOptions]="{ standalone: true }"
          placeholder="Enter deal name" />
      </mat-form-field>

      <div class="required-form__row">
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>Product</mat-label>
          <mat-select formControlName="product">
            @for (option of productOptions(); track option.id) {
              <mat-option [value]="option.id">
                {{ option.label | translate }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>Industry</mat-label>
          <mat-select formControlName="industry">
            @for (option of industryOptions(); track option.id) {
              <mat-option [value]="option.id">
                {{
                  option.name ||
                    (option.label | translate) ||
                    option.description
                }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="review-section">
      <div class="review-section__title">
        {{ 'GNR_TEMPLATES' | translate }}
      </div>
      <div class="required-form__row">
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ 'GNR_NDA_WORKFLOW' | translate }}</mat-label>
          <mat-select formControlName="ndaWorkflow">
            @for (option of ndaWorkflowOptions; track option.value) {
              <mat-option [value]="option.value">
                {{ option.label | translate }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

        @if (showNdaTemplate()) {
          <qt-template-selector
            [templateType]="templateTypes.RTF"
            [label]="'GNR_TEMPLATE'"
            [required]="true"
            formControlName="ndaTemplate">
          </qt-template-selector>
        }
      </div>

      <div class="required-form__row">
        <qt-template-selector
          class="folder-template-selector"
          [templateType]="templateTypes.FOLDER"
          [label]="'GNR_FOLDER_TEMPLATE'"
          [required]="false"
          formControlName="folderTemplate">
        </qt-template-selector>

        <mat-form-field
          class="workflow-template-field"
          appearance="outline"
          subscriptSizing="dynamic">
          <mat-label>Workflow template</mat-label>
          <mat-select formControlName="workflowTemplate" multiple>
            @for (
              group of workflowTemplateGroups$ | async;
              track group.dealName
            ) {
              @if (group.workflows.length > 0) {
                <mat-optgroup [label]="group.dealName || 'Other'">
                  @for (wf of group.workflows; track wf._id) {
                    <mat-option [value]="wf._id">{{ wf.name }}</mat-option>
                  }
                </mat-optgroup>
              }
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </form>

  @for (section of sections; track trackSection($index, section)) {
    <div class="review-section">
      <div class="review-section__title">{{ section.title }}</div>
      <div class="review-fields">
        @for (field of section.fields; track trackField($index, field)) {
          <div
            class="review-field"
            [class.review-field--editing]="field.editing">
            <span class="review-field__label">{{ field.label }}</span>
            @if (!field.editing) {
              <div class="review-field__value-row">
                <span class="review-field__value">{{
                  displayFieldValue(field)
                }}</span>
                @if (isEditable(field)) {
                  <button
                    type="button"
                    class="review-field__edit"
                    (click)="startEdit(field)">
                    <mat-icon>edit</mat-icon>
                  </button>
                }
              </div>
            } @else {
              <div class="review-field__value-row">
                @if (getFieldOptions(field).length > 0) {
                  <mat-select
                    class="review-field__select"
                    [(ngModel)]="field.draft"
                    [ngModelOptions]="{ standalone: true }"
                    (closed)="commitEdit(field)">
                    @for (option of getFieldOptions(field); track option.id) {
                      <mat-option [value]="option.id">{{
                        option.name
                      }}</mat-option>
                    }
                  </mat-select>
                } @else if (field.type === 'date') {
                  <input
                    class="review-field__input"
                    type="date"
                    [(ngModel)]="field.draft"
                    [ngModelOptions]="{ standalone: true }"
                    (keydown)="onEditKeydown($event, field)"
                    (blur)="commitEdit(field)"
                    cdkFocusInitial />
                } @else {
                  <input
                    class="review-field__input"
                    type="text"
                    [(ngModel)]="field.draft"
                    [ngModelOptions]="{ standalone: true }"
                    (keydown)="onEditKeydown($event, field)"
                    (blur)="commitEdit(field)"
                    cdkFocusInitial />
                }
                <button
                  type="button"
                  class="review-field__edit review-field__edit--save"
                  (mousedown)="commitEdit(field)">
                  <mat-icon>check</mat-icon>
                </button>
                <button
                  type="button"
                  class="review-field__edit"
                  (mousedown)="cancelEdit(field)">
                  <mat-icon>close</mat-icon>
                </button>
              </div>
            }
          </div>
        }
      </div>
    </div>
  }

  @if (hasSubFacilities) {
    @for (
      sf of subFacilities;
      track trackSubFacility($index, sf);
      let i = $index
    ) {
      <div class="sub-facility">
        <div class="sub-facility__header">
          <span class="sub-facility__tag">Facility {{ i + 2 }}</span>
          <span class="sub-facility__name">{{
            sf.name || 'Additional facility'
          }}</span>
        </div>
        @for (section of sf.sections; track trackSection($index, section)) {
          <div class="review-section review-section--nested">
            <div class="review-section__title">{{ section.title }}</div>
            <div class="review-fields">
              @for (field of section.fields; track trackField($index, field)) {
                <div
                  class="review-field"
                  [class.review-field--editing]="field.editing">
                  <span class="review-field__label">{{ field.label }}</span>
                  @if (!field.editing) {
                    <div class="review-field__value-row">
                      <span class="review-field__value">{{
                        displaySubFacilityValue(field, sf)
                      }}</span>
                      <button
                        type="button"
                        class="review-field__edit"
                        (click)="startEdit(field)">
                        <mat-icon>edit</mat-icon>
                      </button>
                    </div>
                  } @else {
                    <div class="review-field__value-row">
                      @if (getFieldOptions(field).length > 0) {
                        <mat-select
                          class="review-field__select"
                          [(ngModel)]="field.draft"
                          [ngModelOptions]="{ standalone: true }"
                          (closed)="commitEdit(field)">
                          @for (
                            option of getFieldOptions(field);
                            track option.id
                          ) {
                            <mat-option [value]="option.id">{{
                              option.name
                            }}</mat-option>
                          }
                        </mat-select>
                      } @else if (field.type === 'date') {
                        <input
                          class="review-field__input"
                          type="date"
                          [(ngModel)]="field.draft"
                          [ngModelOptions]="{ standalone: true }"
                          (blur)="commitEdit(field)" />
                      } @else {
                        <input
                          class="review-field__input"
                          type="text"
                          [(ngModel)]="field.draft"
                          [ngModelOptions]="{ standalone: true }"
                          (keydown)="onEditKeydown($event, field)"
                          (blur)="commitEdit(field)"
                          cdkFocusInitial />
                      }
                      <button
                        type="button"
                        class="review-field__edit review-field__edit--save"
                        (mousedown)="commitEdit(field)">
                        <mat-icon>check</mat-icon>
                      </button>
                      <button
                        type="button"
                        class="review-field__edit"
                        (mousedown)="cancelEdit(field)">
                        <mat-icon>close</mat-icon>
                      </button>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        }
      </div>
    }
  }
</mat-dialog-content>

<mat-dialog-actions class="review-footer">
  <div class="review-footer__stat">
    <span class="review-footer__stat-num">{{ totalFieldCount }}</span>
    <span class="review-footer__stat-label">fields detected</span>
  </div>
  <div class="review-footer__actions">
    <button
      type="button"
      mat-stroked-button
      [disabled]="saving()"
      (click)="cancel()">
      Cancel
    </button>
    <button
      type="button"
      mat-flat-button
      class="qt-dialog-primary-button"
      [disabled]="!canSubmit"
      (click)="submit()">
      @if (saving()) {
        <ng-container>
          <mat-spinner diameter="16"></mat-spinner>
          <span>Creating...</span>
        </ng-container>
      } @else {
        <ng-container>
          <span>Submit Deal</span>
          <mat-icon>arrow_forward</mat-icon>
        </ng-container>
      }
    </button>
  </div>
</mat-dialog-actions>
